import useSWRMutation from 'swr/mutation';
import { mutate } from 'swr';

/**
 * Reusable SWR mutation hook with cache invalidation.
 * @param {string} url - The endpoint to post to.
 * @param {function} fetcher - The mutation function (url, data,) => Promise.
 * @param {object} options - { invalidateKey, onSuccess, onError, ... }
 */
export function useCustomMutation(url, fetcher, options = {}) {
  const { invalidateKey, onSuccess, onError, ...rest } = options;

  return useSWRMutation(url, fetcher, {
    onSuccess: (data, key, config) => {
      if (invalidateKey) mutate(invalidateKey);
      if (onSuccess) onSuccess(data, key, config);
    },
    onError,
    throwOnError: false,
    ...rest,
  });
}
